import React, { useState } from 'react'

import LiveTooltip from 'live/components/ui/tooltip'

import { Scrollbars } from '../../../../../../../generic'
import { getStatusCodeColor, transformTSIntoNaturalDate } from '../../../../../../../utils'
import { SystemAudytContentContainer } from './styles'
import i18n from 'live/services/i18n'

interface IProps {
    data: ISystemAudit
    maxHeight: number // see if is important
}

export const SystemAuditContentView: React.FC<IProps> = ({ data, maxHeight }) => {
    const [isOpen, setIsOpen] = useState(false)

    const handleOpenCloseContent = (): void => {
        if (data?.payload || data?.response) {
            setIsOpen(!isOpen)
        }
    }

    const handleFormatJSON = (json: string, type: 'Payload' | 'Response'): JSX.Element => {
        // TODO : see if this is ok
        try {
            let beautifiedJson = null
            if (json) {
                const parsedJson = JSON.parse(json)
                beautifiedJson = JSON.stringify(parsedJson, null, 2)
            }

            return <pre className="json-preview">{`${beautifiedJson ? `${beautifiedJson}` : ''}`}</pre>
        } catch (error) {
            return <pre className="json-preview">unable to parse JSON</pre>
        }
    }

    return (
        <SystemAudytContentContainer statusColor={getStatusCodeColor(data?.statusCode)}>
            <div className={`header c-row`}>
                {console.log('data->', data)}
                <div className="c-col itens-align date"> {transformTSIntoNaturalDate(data?.date)}</div>
                <div className="c-col itens-align description">
                    <span>{i18n('Description')}:</span> {data?.commonQuestionsDto?.what}
                </div>
                <div className="c-col itens-align status-name">
                    <LiveTooltip
                        content={`Status Code: ${data?.statusCode}`}
                        position={'right'}
                        // hide={true}
                    >
                        <span>{data?.statusCodeStatus ? i18n(data.statusCodeStatus) : ''}</span>
                    </LiveTooltip>
                </div>
                <div className="c-col itens-align method">{data?.httpVerb}</div>
                <div className="c-col itens-align plugin-name">{data?.pluginName}</div>
                <div className="c-col itens-align endpoint">{data?.endpoint}</div>
                <div className="c-col itens-align responsible">{data?.liveAuthor}</div>
                <div className="c-col itens-align selection" onClick={handleOpenCloseContent}>
                    {(data?.payload || data?.response) && (
                        <i className={isOpen ? 'fas fa-caret-up' : 'fas fa-caret-down'} />
                    )}
                </div>
            </div>
            {isOpen && (
                <>
                    <div className="c-row width-100">
                        <hr className="line-divisor" />
                    </div>
                    <div className="inner-content c-row width-100">
                        <div
                            className="c-col width-100 scroll-bar-container"
                            style={{
                                height: data?.payload || data?.response ? maxHeight : 0,
                                maxHeight: data?.payload || data?.response ? maxHeight : 0
                            }}
                        >
                            {/* <div className="scroll-bar-container"> */}
                            <Scrollbars>
                                {data?.payload && (
                                    <>
                                        <div className="c-row calendar">
                                            <i className="fas fa-calendar-alt" />
                                            <div className="calendar-text">
                                                {transformTSIntoNaturalDate(data?.date)}
                                            </div>
                                        </div>
                                        <div className="c-row system-request-type-text">{i18n('Server payload')}</div>
                                        <div className="c-row body">
                                            <div className="c-col horizontal-line" />
                                            <div className="c-col json-container">
                                                {handleFormatJSON(data?.payload, 'Payload')}
                                            </div>
                                        </div>
                                    </>
                                )}
                                {data?.response && (
                                    <>
                                        <div className="c-row calendar">
                                            <i className="fas fa-calendar-alt" />{' '}
                                            <div className="calendar-text">
                                                {transformTSIntoNaturalDate(data?.date)}
                                            </div>
                                        </div>
                                        <div className="c-row system-request-type-text">
                                            <div>{i18n('Server response')}</div>
                                            <div className="divisor">|</div>
                                            <div className="system-request-type-status">{data?.statusCode}</div>
                                            <div className="system-request-type-status">
                                                {i18n(data?.statusCodeStatus)}
                                            </div>
                                        </div>
                                        <div className="c-row body">
                                            <div className="c-col horizontal-line" />
                                            <div className="c-col json-container">
                                                {handleFormatJSON(data?.response, 'Response')}
                                            </div>
                                        </div>
                                    </>
                                )}
                            </Scrollbars>
                            {/* </div> */}
                        </div>
                    </div>
                </>
            )}
        </SystemAudytContentContainer>
    )
}
